module.exports = __webpack_public_path__ + "img/hotelFamily-8.1d02abd9.jpg";